export default "__VITE_ASSET__c65dc3b9__"